import React, { useState, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  List,
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Fade } from '@mui/material';
import { VoucherDetailsSection } from "./voucherDetailsSection";
import { VoucherDetailsSection1 } from "./voucherDetailsSection1";
import { PartnershipForm } from "./partnershipForm";
export default function PartnerWithUs() {
  const partnershipFormRef = useRef(null);

  const scrollToPartnershipForm = () => {
    if (partnershipFormRef.current) {
      partnershipFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
   const [allExpanded, setAllExpanded] = useState(false);
   const handleToggleAll = () => {
   setAllExpanded((prev) => !prev);
  };
  return (
    <Fade in={true} timeout={600}>
    <Box sx={{ backgroundColor: "#fff", color: "#002e5b", p: 3, mt: { xs: 8, lg: 16}, mb: 8 }}>
      <Box
        textAlign="center"
        py={6}
        sx={{
          background: "linear-gradient(to right, #0077b6, #00b4d8)",
          color: "#fff",
        }}
      >
        <Typography variant="h3" fontWeight={600}>
          Partner With Us
        </Typography>
        <Typography variant="h6" mt={2}>
          Strategic Collaboration in Wellness and Logistics
        </Typography>
      
      </Box>

<Box 
  py={3} 
  display="flex" 
  flexDirection={{ xs: "column", md: "row" }}
  alignItems="center" 
  justifyContent="space-between"
  gap={{ xs: 2, md: 0 }}
>
  <Box 
    flex="1" 
    textAlign="center" 
    sx={{ ml: { xs: 0, md: 20, lg: 20 } }}
  >
    <Typography variant="h5" fontWeight={600}>
      The Great Himalayas
    </Typography>
  </Box>

  <Box width={{ xs: "100%", md: "auto" }}>
    <Button 
      variant="contained" 
      color="primary" 
      onClick={scrollToPartnershipForm}
      sx={{ width: { xs: "100%", md: "auto" } }}
    >
      Partnership Form
    </Button>
  </Box>
</Box>



      <Box textAlign="center">
       
        <Typography mt={-2}>
          Travel & Logistics Solutions | Sikkim, Darjeeling & Northeast India
        </Typography>
        <Typography mt={1}>
          A Brand of HimalayanZenith Ventures Private Limited
        </Typography>
        <Typography mt={3} fontWeight={600}>
          Partnership Proposal
        </Typography>
        <Typography>
  Tours, Cab Services, and Logistics Support for Wellness, Adventure, Cultural, and Travel Packages
</Typography>

      </Box>
      <VoucherDetailsSection /> 

      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>1. ABOUT THE GREAT HIMALAYAS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography fontWeight={600} marginBottom={2}>Company Overview</Typography>
          <Typography>
            The Great Himalayas (operated by <b>HimalayanZenith Ventures Pvt. Ltd.</b>)
            is a specialized travel and logistics service provider across
            Northeast India. We deliver exceptional mountain experiences through
            professional service and local expertise.
          </Typography>
          <Typography><b>Established:</b> 2024</Typography>
          <Typography>
            <b>Headquarters:</b> Siliguri, Darjeeling District, West Bengal
          </Typography>
          <Typography>
            <b>Legal Entity:</b> HimalayanZenith Ventures Private Limited
          </Typography>
          <Typography><b>Website:</b> www.thegreathimalayas.com</Typography>

          <Typography fontWeight={600} marginTop={2}>
            Core Competencies
          </Typography>
          <Typography marginTop={2}>
            <b>Cab & Transportation Services</b> - Comprehensive fleet including
            sedans, SUVs, tempo travellers, and mini buses - Professional,
            experienced drivers with deep regional knowledge - Airport and
            railway station transfers (Bagdogra, NJP, Gangtok) - Local,
            outstation, and hourly rental services - Multi-day tour
            transportation with luggage support
          </Typography>
          <Typography marginTop={1}>
            <b>Tour Operations</b> - Wellness retreats and digital detox programs in
            nature farms - Adventure tours and trekking packages - Cultural and
            heritage exploration tours - Nature and wildlife experiences -
            Customized group travel and corporate outings - Family vacation
            packages
          </Typography>
          <Typography marginTop={1}>
            <b>Regional Expertise</b> - Deep knowledge of Sikkim (Gangtok, Pelling,
            Lachung, Lachen, Ravangla, Namchi) - Darjeeling and Kalimpong
            specialist - North Bengal coverage (Siliguri, Dooars, Jalpaiguri) -
            Extended Northeast India destinations (Meghalaya, Arunachal Pradesh,
            Assam)
          </Typography>
          <Typography marginTop={1}>
            <b>Logistics Network</b> - Established relationships with 50+ accommodation
            providers (hotels, resorts, homestays, retreat centers) - Network of
            verified local guides, activity coordinators, and wellness
            practitioners - Partnerships with restaurants, cafes, and organic
            food suppliers - Access to adventure equipment providers and
            activity vendors
          </Typography>
          <Typography marginTop={1}>
            <b>Digital Infrastructure</b> - Modern booking portal:
            thegreathimalayas.com - Online inquiry and quotation system -
            WhatsApp-based customer service and booking management - Social
            media presence across Facebook and Instagram - Email marketing and
            customer relationship management
          </Typography>

          <Typography fontWeight={600} marginTop={2}>
            Our Unique Value Proposition
          </Typography>
          <Typography marginTop={2}>
            <b>Local Expertise Meets Professional Service</b>: We combine deep regional
            knowledge, cultural understanding, and local connections with modern
            business practices, transparent pricing, and customer-first service
            standards.
          </Typography>
          <Typography marginTop={1}>
            <b>Wellness Tourism Specialization:</b> Beyond standard tours, we focus on
            transformational wellness experiences including digital detox
            programs, nature immersion retreats, and holistic healing journeys
            in the pristine Himalayan environment.
          </Typography>
          <Typography marginTop={1}>
            <b>Reliability & Safety:</b> Professional drivers, well-maintained
            vehicles, 24/7 customer support, comprehensive insurance, and
            emergency response protocols ensure participant safety and peace of
            mind.
          </Typography>
          <Typography marginTop={1}>
            <b>Sustainable & Responsible Tourism:</b> We promote eco-friendly travel
            practices, support local communities, partner with sustainable
            properties, and encourage responsible tourism that preserves the
            natural and cultural heritage of the region.
          </Typography>
        </AccordionDetails>
      </Accordion>
      {/* Repeat Accordion for each major section */}
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>2. PARTNERSHIP OBJECTIVES</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            We propose a <b>mutually beneficial strategic partnership</b> with the
            following objectives:
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            A. Logistics & Operational Support
          </Typography>
          <Typography marginTop={1}>
            Provide end-to-end logistics management for your wellness programs
            in our operational regions, ensuring seamless execution and enhanced
            participant experience.
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            B. Market Expansion & Distribution
          </Typography>
          <Typography marginTop={1}>
            List and promote your wellness programs on our digital platform
            (thegreathimalayas.com), expanding your market reach to our customer
            base and partner networks.
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            C. Revenue Growth
          </Typography>
          <Typography marginTop={1}>
            Create additional revenue streams for both organizations through
            commission-based bookings and shared operational efficiencies.
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            D. Brand Enhancement
          </Typography>
          <Typography marginTop={1}>
            Leverage our regional brand presence and your wellness expertise to
            position both organizations as preferred wellness tourism partners
            in Northeast India.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>
            3. PROPOSED PARTNERSHIP STRUCTURE
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography fontWeight={600}>
            OPTION A: Comprehensive Logistics Partnership
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            Services We Provide:
          </Typography>
          <Typography marginTop={2}>
           <b>✓ Ground Transportation:</b>  Airport/railway pickups (Bagdogra, NJP,
            Gangtok), inter-city transfers, local travel, and all participant
            transportation needs throughout program duration
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Accommodation Coordination:</b> Booking, management, and quality
            assurance of hotels, resorts, homestays, or retreat properties
            aligned with your program
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Vendor Management:</b> Coordination with local service providers
            including yoga instructors, meditation guides, nutritionists,
            activity coordinators, spa facilities, and wellness practitioners
          </Typography>
          <Typography marginTop={1}>
            <b>✓ On-Ground Support:</b> Dedicated program coordinators, 24/7 emergency
            assistance hotline, and continuous participant support throughout
            program duration
          </Typography>
          <Typography marginTop={1}>
           <b>✓ Meal & Catering Logistics:</b>  Arrangement of organic, farm-to-table
            meals, special dietary requirements, and wellness-focused cuisine
            aligned with program philosophy
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Activity Coordination:</b> Scheduling and logistics for nature walks,
            forest treks, meditation sessions, cultural immersion experiences,
            and wellness activities
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Local Permits & Compliance:</b> Handling of protected area permits,
            tourism registrations, insurance coordination, and regulatory
            requirements
          </Typography>
          <Typography marginTop={1}>
           <b>✓ Pre-Program Reconnaissance:</b> Site visits, quality checks, vendor
            vetting, and program customization based on your specific
            requirements and standards
          </Typography>
          <Typography marginTop={2}>
            <b>Pricing Model:</b> - Flat per-participant logistics fee based on program
            duration and services required - Transparent pricing with itemized
            cost breakdown - Seasonal rate adjustments communicated 90 days in
            advance - Volume discounts for multiple programs or high participant
            numbers (10+ participants: 10% discount, 20+ participants: 15%
            discount)
          </Typography>
        </AccordionDetails>
        <AccordionDetails>
          <Typography fontWeight={600}>
            OPTION B: Distribution & Sales Partnership
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            Services We Provide:
          </Typography>
          <Typography marginTop={2}>
            <b>✓ Digital Distribution:</b> Feature your wellness programs prominently
            on thegreathimalayas.com with dedicated landing pages, detailed
            itineraries, and booking functionality
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Marketing Promotion:</b> Inclusion in our social media campaigns
            (Facebook, Instagram), email marketing to 2,000+ subscribers, and
            WhatsApp broadcast campaigns to segmented customer lists
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Lead Generation:</b> Direct customer inquiries and bookings through
            our website, social channels, and customer relationship network
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Booking Management:</b> Handle customer inquiries, customized
            quotations, booking confirmations, payment collection, and
            pre-travel communication on your behalf
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Customer Support:</b> Pre-program consultations, itinerary
            customization, travel logistics advice, and post-program follow-up
            to ensure satisfaction
          </Typography>
          <Typography marginTop={1}>
            <b>✓ Content Creation:</b> Professional photography, videography, written
            content, and testimonial collection showcasing your programs
          </Typography>
          <Typography marginTop={1}>
            <b>✓ SEO & Online Presence:</b> Optimize your program visibility through
            our established digital marketing channels, search engine
            optimization, and content marketing
          </Typography>
          <Typography marginTop={2}>
            <b>Commission Structure: - Standard Commission:</b> 15% on gross booking
            value for programs we sell through our channels - <b>Tiered Commission:</b>
            12% for bookings exceeding 50 participants annually - <b>Logistics
            Bundle Discount:</b> If you also engage our logistics services (Option
            A), commission reduces to 10%
          </Typography>
        </AccordionDetails>
        <AccordionDetails>
          <Typography fontWeight={600}>
            OPTION C: Integrated Partnership (Recommended)
          </Typography>
          <Typography fontWeight={600} marginTop={2}>
            Combine Options A + B for maximum value:
          </Typography>
          <Typography marginTop={2}>
            ✓ Full logistics and operational support across Northeast India
          </Typography>
          <Typography marginTop={1}>
            ✓ Comprehensive digital distribution and marketing through our
            platform
          </Typography>
          <Typography marginTop={1}>
            ✓ Bundled pricing with preferential rates
          </Typography>
          <Typography marginTop={1}>
            ✓ Co-branded wellness programs unique to our partnership
          </Typography>
          <Typography marginTop={1}>
            ✓ Shared revenue model with transparent accounting
          </Typography>

          <Typography marginTop={2}>
            <b>Integrated Pricing: - Logistics Fee:</b> Competitive per-participant
            rate (20% below standalone Option A pricing) - <b>Commission Rate:</b> 10%
            on program bookings (reduced from 15% due to bundled services) -
            <b>bJoint Program Development:</b> Revenue-sharing model (60% Partner / 40%
            The Great Himalayas) for co-created exclusive programs
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>4. PARTNERSHIP BENEFITS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography fontWeight={600} marginTop={2}>
            Benefits to Your Organization:
          </Typography>

          <Typography marginTop={2}>
            <b>Operational Efficiency</b> - Focus on program content, curriculum, and
            participant experience while we handle complex ground logistics -
            Eliminate need for local coordination, vendor sourcing, quality
            control, and on-ground troubleshooting - Leverage our established
            regional network, vendor relationships, and operational expertise
          </Typography>

          <Typography marginTop={1}>
            <b>Cost Optimization</b> - Access preferential rates through our vendor
            relationships and bulk purchasing power - Reduce operational
            overhead and staffing requirements for regional programs -
            Transparent, predictable pricing structure with no surprise costs or
            hidden fees - Volume-based discounts for long-term partnership
            commitments
          </Typography>

          <Typography marginTop={1}>
            <b>Risk Mitigation</b> - Local expertise ensures compliance with permits,
            regulations, safety standards, and insurance requirements - 24/7
            emergency support and contingency planning for weather, medical, or
            logistical challenges - Professional drivers with commercial
            licenses and comprehensive vehicle insurance - Emergency medical
            coordination with local hospitals and healthcare facilities
          </Typography>

          <Typography marginTop={1}>
            <b>Market Expansion</b> - Immediate access to our established customer base
            and Northeast India distribution channels - Enhanced visibility
            through our digital marketing, social media presence, and regional
            brand recognition - Tap into corporate, individual, group travel,
            and wellness-seeking markets we serve - Leverage our relationships
            with hotels, travel agents, and corporate partners for referrals
          </Typography>
          <Typography marginTop={1}>
            <b>Seamless Experience</b> - White-label logistics services maintaining
            your brand identity and participant touchpoints - Consistent service
            quality aligned with your wellness program standards and values -
            Positive participant feedback driving repeat bookings, testimonials,
            and referrals - Professional communication and coordination
            throughout the participant journey
          </Typography>

          <Typography fontWeight={600} marginTop={2}>
            Benefits to The Great Himalayas:
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
          <li><Typography marginTop={2}>
            Expand service portfolio with premium wellness content and
            specialized programs
          </Typography>
</li>
         <li> <Typography marginTop={1}>
            Access your established wellness program expertise, curriculum, and
            customer base
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
            Create differentiated offerings in competitive Northeast India
            travel market
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
            Build long-term recurring revenue through sustained partnership
            programs
          </Typography>
          </li>
          <li>
          <Typography marginTop={1}>
            Enhance brand positioning as wellness tourism specialist in the
            region
          </Typography>
          </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>5. OPERATIONAL FRAMEWORK</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography fontWeight={600} marginTop={2}>
            Roles & Responsibilities
          </Typography>

          <Typography marginTop={2}>
            <b>Wellness Program Partner Responsibilities:</b> - Program design,
            wellness content, curriculum, and participant materials - Wellness
            instructors, yoga teachers, meditation facilitators, and specialized
            practitioners - Marketing materials, brand assets, program
            descriptions, and promotional content - Pricing structure, program
            inclusions, and participant eligibility criteria - Quality
            standards, participant satisfaction protocols, and program
            evaluation{" "}
          </Typography>

          <Typography marginTop={1}>
            <b>The Great Himalayas Responsibilities:</b> - Ground transportation
            logistics and vehicle coordination - Accommodation sourcing,
            booking, quality checks, and relationship management - Local vendor
            coordination (guides, activity providers, catering, equipment) -
            On-ground participant support, program coordination, and daily
            operations - Emergency assistance, medical coordination, and
            contingency management - Digital marketing, website listing, lead
            generation, and booking management (if Option B/C selected) -
            Payment collection, financial reconciliation, and transparent
            reporting
          </Typography>

          <Typography fontWeight={600} marginTop={2}>
            Communication & Coordination
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
  <li>
          <Typography marginTop={2}>
            <b>Dedicated Account Manager:</b> Single point of contact (partnership
            manager) for all partnership matters, queries, and coordination
          </Typography>
</li>
      <li>   <Typography marginTop={1}>
            <b>Pre-Program Planning:</b> Joint planning meetings 30-45 days before each
            program to align on logistics, participant needs, and special
            requirements
          </Typography>
</li> 
      <li>    <Typography marginTop={1}>
            <b>Real-Time Updates:</b> Dedicated WhatsApp group for immediate
            communication during active programs with program coordinator,
            driver, and management
          </Typography>
</li>
     <li>    <Typography marginTop={1}>
            <b>Post-Program Review:</b> Debriefing sessions within 7 days of program
            completion to assess performance, gather feedback, and identify
            improvements
          </Typography>
          </li> 
      <li>   <Typography marginTop={1}>
            <b>Quarterly Business Review:</b> Strategic discussions on partnership
            performance, booking trends, growth opportunities, market
            developments, and expansion plans
          </Typography>
          </li> 
</ul>
          <Typography fontWeight={600} marginTop={2}>
            Quality Assurance
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
          <li><Typography marginTop={2}>
            Service level agreements (SLAs) defining response times, quality
            standards, safety protocols, and performance metrics
          </Typography>
</li>
         <li><Typography marginTop={1}>
            Pre-program property inspections and vendor quality audits
          </Typography>
</li> 
        <li> <Typography marginTop={1}>
            Participant feedback collection through surveys and testimonials
          </Typography>
</li> 
       <li>   <Typography marginTop={1}>
            Continuous improvement protocols based on feedback and partnership
            reviews
          </Typography>
          </li>
       <li> <Typography marginTop={1}>
            Regular vehicle maintenance, driver training, and safety compliance
            checks
          </Typography>
          
          </li>  
       <li>   <Typography marginTop={1}>
            Annual partnership review with performance analysis and strategic
            planning
          </Typography>
          </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>6. FINANCIAL ARRANGEMENTS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography fontWeight={600} marginTop={2}>
            Payment Terms
          </Typography>

          <Typography marginTop={2}>
            <b>For Logistics Services (Option A):</b> - 30% advance upon program
            confirmation (non-refundable after 45 days before program) - 70%
            balance payment 15 days before program commencement - Invoicing to
            partner organization with detailed cost breakdown and itemized
            services - Bank transfer, UPI, or online payment options available
          </Typography>

          <Typography marginTop={1}>
            <b>For Distribution Services (Option B):</b> - Commission deducted from
            participant payments collected through our platform - Monthly
            commission statements with booking details, revenue breakdown, and
            commission calculation - Payment to partner within 15 days
            post-program completion after participant feedback received -
            Transparent reporting dashboard with real-time booking and revenue
            tracking
          </Typography>
          <Typography marginTop={1}>
            <b>For Integrated Partnership (Option C):</b> - Hybrid payment structure
            combining both models above - Flexible payment terms negotiable
            based on program volume and partnership duration - Annual contracts
            with preferred pricing and payment schedules available
          </Typography>

          <Typography fontWeight={600} marginTop={2}>
            Pricing Transparency
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
<li>
          <Typography marginTop={2}>
            All pricing provided in advance with detailed cost breakdowns by
            service category
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
            No hidden fees, surprise charges, or last-minute cost escalations
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
            Seasonal rate variations (peak/off-peak) communicated minimum 90
            days in advance
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
            Volume discounts for annual commitments, multiple programs, or high
            participant numbers
          </Typography>
          </li>
          <li>
          <Typography marginTop={1}>
            Fuel surcharge policy: Any fuel price increase by 15% may result in
            rate adjustment with 30 days notice
          </Typography>
          </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>
            7. PARTNERSHIP DURATION & TERMS
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography marginTop={2}>
            <b>Initial Term:</b> 12 months from partnership agreement execution date
          </Typography>

          <Typography marginTop={1}>
            <b>Renewal:</b> Automatic renewal for successive 12-month periods unless
            either party provides 60 days written notice of non-renewal{" "}
          </Typography>
          <Typography marginTop={1}>
            <b>Trial Period:</b> Optional 3-month pilot program with 2 wellness
            programs to evaluate partnership fit, service quality, and business
            alignment before full commitment
          </Typography>

          <Typography marginTop={1}>
            <b>Termination:</b> Either party may terminate with 90 days written notice;
            ongoing booked programs honored and completed regardless of
            termination notice
          </Typography>

          <Typography marginTop={1}>
            <b>Non-Compete:</b> During active partnership term, neither party will
            engage with direct competitors for similar logistics or distribution
            arrangements in defined Northeast India geographic region
          </Typography>

          <Typography marginTop={1}>
            <b>Confidentiality:</b> Both parties agree to maintain confidentiality of
            pricing, customer data, business strategies, and proprietary
            information
          </Typography>

          <Typography marginTop={1}>
            <b>Exclusivity (Optional):</b> Negotiable exclusive logistics partnership
            within Northeast India region for premium pricing consideration and
            priority resource allocation
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>8. GEOGRAPHIC COVERAGE</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography marginTop={2} fontWeight={600}>
            Primary Service Areas (Immediate Availability):
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
          <li><Typography marginTop={2}>
            <b>Sikkim:</b> Gangtok, Pelling, Lachung, Lachen, Ravangla, Namchi, Yuksom,
            Zuluk
          </Typography></li>
          <li><Typography marginTop={1}>
            <b>Darjeeling & Kalimpong:</b> Darjeeling town, Tiger Hill, Kalimpong,
            Mirik, Kurseong
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
           <b> North Bengal:</b> Siliguri, Dooars region, Jalpaiguri, Gorumara,
            Jaldapara
          </Typography>
          </li>
          </ul>

          <Typography marginTop={2} fontWeight={600}>
            Extended Coverage (with 15-30 days advance notice):
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
  <li>
    <Typography>
      <b>Arunachal Pradesh:</b> Tawang, Bomdila, Ziro, Dirang
    </Typography>
  </li>
  <li>
    <Typography>
      <b>Meghalaya:</b> Shillong, Cherrapunji, Mawlynnong, Dawki
    </Typography>
  </li>
  <li>
    <Typography>
      <b>Assam:</b> Guwahati, Kaziranga National Park, Majuli Island
    </Typography>
  </li>
  <li>
    <Typography>
      <b>West Bengal Hills:</b> Sandakphu, Singalila Ridge
    </Typography>
  </li>
</ul>

 
          <Typography marginTop={2} fontWeight={600}>
            Transportation Hubs:
          </Typography>
<ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "8px" }}>
<li>
          <Typography marginTop={2}>
            Bagdogra Airport (IXB) - 15 minutes from Siliguri
          </Typography>
</li>
<li>
          <Typography marginTop={1}>
            New Jalpaiguri Railway Station (NJP) - Major railhead for Northeast
            India
          </Typography>
          </li>
          <li>
          <Typography marginTop={1}>
            Gangtok (Pakyong Airport) - 35 km from Gangtok city
          </Typography>
          </li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>9. NEXT STEPS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography marginTop={2}>
            We propose the following timeline to initiate our partnership:
          </Typography>

          <Typography marginTop={2}>
            <b>Week 1-2:</b> Initial partnership discussions, clarification calls, site
            visit to our operations (optional), and mutual due diligence
          </Typography>
          <Typography marginTop={1}>
            <b>Week 3:</b> Finalize preferred partnership model (Option A, B, or C),
            negotiate commercial terms, and draft service level agreements
          </Typography>

          <Typography marginTop={1}>
            <b>Week 4:</b> Legal review, partnership agreement execution, and formal
            contract signing
          </Typography>
          <Typography marginTop={1}>
            <b>Week 5-6:</b> Onboarding process including system integration,
            communication protocols setup, vendor introductions, and joint
            planning for first program
          </Typography>
          <Typography marginTop={1}>
           <b> Week 7+:</b> Launch partnership with pilot program or full-scale
            implementation with marketing rollout
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>10. CONTACT INFORMATION</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography marginTop={1} fontWeight={600}>
            For Partnership Inquiries:{" "}
          </Typography>

          <Typography marginTop={2} fontWeight={600}>
            Company Name:
          </Typography>
          <Typography>The Great Himalayas</Typography>

          <Typography>
            (A Brand of HimalayanZenith Ventures Private Limited)
          </Typography>

          <Typography marginTop={2} fontWeight={600}>
            Primary Contact:
          </Typography>
          <Typography>Founder & Partnerships Director</Typography>
          <Typography>The Great Himalayas</Typography>

          <Typography marginTop={1}>
            Email: contact@thegreathimalayas.com
          </Typography>
          <Typography>Phone/WhatsApp: +91 9883587965</Typography>
          <Typography>Website: www.thegreathimalayas.com</Typography>

          <Typography marginTop={1} fontWeight={600}>
            Registered Office Address:
          </Typography>
          <Typography>Siliguri, Darjeeling District</Typography>
          <Typography>West Bengal - 734001</Typography>
          <Typography>India</Typography>

          <Typography marginTop={1} fontWeight={600}>
            Business Hours:
          </Typography>
          <Typography>Monday - Saturday: 9:00 AM - 7:00 PM IST</Typography>
          <Typography>Sunday: 10:00 AM - 5:00 PM IST</Typography>
          <Typography>
            (Emergency support available 24/7 during active programs)
          </Typography>

          <Typography marginTop={2} fontWeight={600}>
            How to Reach Us:
          </Typography>
          <Typography marginTop={2} fontWeight={600}>
            For General Inquiries:
          </Typography>
          <Typography>Email: contact@thegreathimalayas.com</Typography>
          <Typography>Response Time: Within 24 hours</Typography>

          <Typography marginTop={2} fontWeight={600}>
            For Partnership Discussions:
          </Typography>
          <Typography>Phone/WhatsApp: +91 9883587965</Typography>
          <Typography>Best calling hours: 10 AM - 6 PM IST</Typography>
          <Typography>
            Email follow-up recommended for detailed proposals
          </Typography>

          <Typography marginTop={2} fontWeight={600}>
            For Urgent Matters During Programs:
          </Typography>
          <Typography>24/7 Emergency Hotline: +91 9883587965</Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={allExpanded} onChange={handleToggleAll}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>CONCLUSION</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography marginTop={2}>
            The Great Himalayas (HimalayanZenith Ventures Private Limited) is
            committed to being more than a logistics provider—we aspire to be
            your trusted strategic partner in delivering transformational
            wellness experiences across Northeast India. Our regional expertise,
            operational excellence, professional service standards, and digital
            distribution capabilities position us uniquely to support your
            growth objectives while ensuring exceptional participant
            satisfaction
          </Typography>
          <Typography marginTop={1}>
            With our established infrastructure in Siliguri and deep connections
            throughout Sikkim, Darjeeling, and Northeast India, we offer
            reliability, local knowledge, and operational capabilities that
            enable your wellness programs to thrive in this pristine Himalayan
            environment.
          </Typography>

          <Typography marginTop={1}>
            We look forward to exploring this partnership opportunity and
            creating lasting value for both our organizations and the wellness
            travelers we serve together.
          </Typography>

          <Typography marginTop={1} fontWeight={600}>
            We welcome the opportunity to discuss this proposal in detail at
            your earliest convenience. Please reach out via email or WhatsApp to
            schedule an introductory call.
          </Typography>

          <Typography marginTop={2} fontWeight={600}>
            Attachments Available Upon Request:
          </Typography>

          <Typography marginTop={1}>
            1. Company Profile & Service Portfolio
          </Typography>
          <Typography marginTop={1}>
            2. Fleet & Infrastructure Overview (Vehicle Photos, Driver Profiles)
          </Typography>
          <Typography marginTop={1}>
            3. Sample Wellness Program Itineraries
          </Typography>
          <Typography marginTop={1}>
            4. Client Testimonials & Case Studies
          </Typography>

          <Typography marginTop={1}>
            5. Regional Coverage Map with Destinations
          </Typography>
           <Typography marginTop={1}>
            6. Partnership Agreement Draft Template
          </Typography>
          <Typography marginTop={1}>
            7. Accommodation Partner Network List
          </Typography>
          <Typography marginTop={1}>
            8. Vendor & Service Provider Directory
          </Typography>
          <Typography marginTop={1}>
            9. Safety & Emergency Response Protocols
          </Typography>

          <Typography marginTop={1}>
            10.Insurance & Legal Compliance Documents
          </Typography>
        </AccordionDetails>
      </Accordion>
       <VoucherDetailsSection1/>
        <div ref={partnershipFormRef} id="partnershipFormSection">
        <PartnershipForm />
      </div>
    </Box>
   
    </Fade>
  );
}
